// import {
//   CanActivateFn,
//   GuardResult,
//   MaybeAsync,
//   Router,
// } from "@angular/router";
// import { CookieHandler } from "./cookie-handler";
// import { inject } from "@angular/core";

// export const AuthGuard: CanActivateFn = (): MaybeAsync<GuardResult> => {
//   if (CookieHandler.getToken()) {
//     return true;
//   }

//   inject(Router).navigate(["/login"]);

//   return false;
// };

import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { CookieHandler } from "./cookie-handler";

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);

  const token = CookieHandler.getToken();

  if (token) {
    return true;
  }

  // اگر توکن وجود نداشت، کاربر رو به صفحه لاگین هدایت می‌کنیم
  router.navigate(["/login"]);
  return false;
};
